import { CATALOG_DATA_URL } from "../../../../utils/urls"
import { countryNameByCode } from "../../countries"
import { GetCatalog, ResponseCatalog } from "./types"

export const mapCountries = (countries: string[]) =>
  countries
    .filter(code => code !== "CS")
    .map(code => ({
      code,
      label: countryNameByCode(code),
    }))
export const catalogService = {
  getCatalog: (): Promise<GetCatalog> =>
    fetch(CATALOG_DATA_URL)
      .then<ResponseCatalog>(res => res.json())
      .then(response => ({
        currencies: response.currencies,
        catalog: response.catalog.map(catalog => ({
          id: catalog.id,
          countries: mapCountries(catalog.countries),
          countryCodes: catalog.countries,
          cardImagePath: catalog.card_image_path,
          currencyCodes: catalog.currency_codes,
          logoImagePath: catalog.logo_image_path,
          name: catalog.name,
          category: catalog.category,
        })),
      })),
}
